module.exports = __webpack_public_path__ + "static/media/instagram.a770cae3.svg";